// removed by extract-text-webpack-plugin
module.exports = {"footer":"G_tSfgp_A _6rexmpxuB","link":"G4uxFPSFI _3R5YvpqNN _2xjT38Lqf _43dVJeXbT","separator":"_11xMV0Bud _2qV3kzJTO _1IHyVxoAL","footer-row":"_1CNyNcsC2 _1pOLDbgQd f_g9-xYJH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/footer/footer.css
 ** module id = 2111
 ** module chunks = 0
 **/